import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangeBrand = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 25,
	fill: "none",
	viewBox: "0 0 28 25",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M25.7914 17H27.2914V24H25.7914V23.53C25.4614 23.91 24.9714 24.14 24.3014 24.14C22.9914 24.14 21.9114 22.99 21.9114 21.5C21.9114 20.01 22.9914 18.86 24.3014 18.86C24.9714 18.86 25.4614 19.09 25.7914 19.47V17ZM24.6014 22.72C25.2914 22.72 25.7914 22.25 25.7914 21.5C25.7914 20.75 25.2914 20.28 24.6014 20.28C23.9114 20.28 23.4114 20.75 23.4114 21.5C23.4114 22.25 23.9114 22.72 24.6014 22.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M19.2613 18.86C20.2713 18.86 21.1313 19.58 21.1313 20.93V24H19.6313V21.15C19.6313 20.53 19.2413 20.24 18.7613 20.24C18.2113 20.24 17.8313 20.56 17.8313 21.27V24H16.3313V19H17.8313V19.47C18.1013 19.1 18.6013 18.86 19.2613 18.86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M13.7309 19H15.2309V24H13.7309V23.53C13.4009 23.91 12.9109 24.14 12.2409 24.14C10.9309 24.14 9.85088 22.99 9.85088 21.5C9.85088 20.01 10.9309 18.86 12.2409 18.86C12.9109 18.86 13.4009 19.09 13.7309 19.47V19ZM12.5409 22.72C13.2309 22.72 13.7309 22.25 13.7309 21.5C13.7309 20.75 13.2309 20.28 12.5409 20.28C11.8509 20.28 11.3509 20.75 11.3509 21.5C11.3509 22.25 11.8509 22.72 12.5409 22.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M8.04619 19.89C8.24619 19.22 8.91619 18.9 9.54619 18.9V20.6C8.92619 20.5 8.04619 20.75 8.04619 21.74V24H6.54619V19H8.04619V19.89Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M4.9401 20.37C5.4601 20.7 5.8001 21.24 5.8001 21.95C5.8001 23.19 4.7901 24 3.5401 24H0.600098V17H3.3401C4.5601 17 5.5501 17.79 5.5501 19C5.5501 19.58 5.3201 20.04 4.9401 20.37ZM3.3401 18.5H2.2001V19.74H3.3401C3.7001 19.74 3.9501 19.48 3.9501 19.12C3.9501 18.76 3.7101 18.5 3.3401 18.5ZM3.5401 22.5C3.9401 22.5 4.2001 22.22 4.2001 21.83C4.2001 21.44 3.9401 21.16 3.5401 21.16H2.2001V22.5H3.5401Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M6.00012 7.00004C6.00012 7.55316 6.447 8.00004 7.00012 8.00004C7.55325 8.00004 8.00012 7.55316 8.00012 7.00004C8.00012 5.34379 9.34387 4.00004 11.0001 4.00004H16.0001V5.00004C16.0001 5.40316 16.2439 5.76879 16.6189 5.92504C16.9939 6.08129 17.422 5.99379 17.7095 5.70941L19.7095 3.70941C20.1001 3.31879 20.1001 2.68441 19.7095 2.29379L17.7095 0.293788C17.422 0.00628796 16.9939 -0.078087 16.6189 0.078163C16.2439 0.234413 16.0001 0.596913 16.0001 1.00004V2.00004H11.0001C8.23762 2.00004 6.00012 4.23754 6.00012 7.00004ZM22.0001 9.00004C22.0001 8.44691 21.5532 8.00004 21.0001 8.00004C20.447 8.00004 20.0001 8.44691 20.0001 9.00004C20.0001 10.6563 18.6564 12 17.0001 12H12.0001V11C12.0001 10.5969 11.7564 10.2313 11.3814 10.075C11.0064 9.91879 10.5782 10.0063 10.2907 10.2907L8.29075 12.2907C7.90012 12.6813 7.90012 13.3157 8.29075 13.7063L10.2907 15.7063C10.5782 15.9938 11.0064 16.0782 11.3814 15.9219C11.7564 15.7657 12.0001 15.4032 12.0001 14.9969V14H17.0001C19.7626 14 22.0001 11.7625 22.0001 9.00004Z"
		})
	]
});
const ForwardRef = forwardRef(SvgChangeBrand);
export default ForwardRef;
